// extracted by mini-css-extract-plugin
export var addWidgetButton = "_r-6";
export var backButton = "_r-1";
export var legacyWidgetContainer = "_r-5";
export var pageContainer = "_r-2";
export var settingsContent = "_r-0";
export var widgetSubsectionItem = "_r-3";
export var widgetSubsectionItemContent = "_r-4";